<template>
  <div class="input">
    <div class="input-label">イベント名</div>
    <div class="input-group">
      <input type="text" class="input-text" v-model="name">
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    name: {
      get: function () {
        return this.$store.state.event.name
      },

      set: function (value) {
        this.$store.commit(
          'event/setName',
          value
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
